import "./Loader.css"
const DashboardLoader = () => {
  return (
    <div className="dashboard-loader">
      <span className="loader"></span>
    </div>
  )
}

export default DashboardLoader
